import { Briefcase, Home, ShoppingBag } from "lucide-react";

const SecondData = [
    {
      id: 1,
      icon: Home,
      title: "Home Sweet Home",
      description: "Find comfort and peace in your own space with our premium home solutions."
    },
    {
      id: 2,
      icon: Briefcase,
      title: "Work Smart",
      description: "Enhance productivity with the best tools and strategies for a successful career."
    },
    {
      id: 3,
      icon: ShoppingBag,
      title: "Shop With Ease",
      description: "Get the best deals on quality products, delivered right to your doorstep."
    },
  ];
  
  export default SecondData;